import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { ROUTE_CONSTANTS } from 'constants/route';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#0f487e',
  },
  navigation: {
    padding: '4rem 0',
  },
  navigationSection: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
  },
  navigationSectionTitle: {
    display: 'block',
    width: '200px',
    fontSize: '0.75rem',
    marginBottom: '0.25rem',
    fontWeight: 'bold',
    color: '#fff',
  },
  links: {
    display: 'inline-block',
    width: '200px',
    listStyle: 'none',
    padding: '0 0 0 0.75rem',
    '& a': {
      color: '#fff',
      textDecoration: 'none',
      fontSize: '0.75rem',
      '&:hover': {
        textDecoration: 'underline',
        color: '#fff',
      },
    },
  },
  copyright: {
    marginTop: '4rem',
    textAlign: 'center',
    fontSize: '0.75rem',
    marginBottom: '0.5rem',
    color: '#fff',
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={`${classes.root} print-footer`}>
      <Container>
        <footer>
          <Grid container spacing={0} className={classes.navigation}>
            <Grid item xs={12} sm={6} className={classes.navigationSection}>
              <div className={classes.centerContainer}>
                <div className={classes.navigationSectionTitle}>MSLA</div>
                <ul className={classes.links}>
                  <li>
                    <a href="https://www.msla.org">MSLA Home</a>
                  </li>
                  <li>
                    <a href="https://www.msla.org/about-msla/staff-information/">MSLA Staff</a>
                  </li>
                  <li>
                    <a href="https://www.msla.org/about-msla/website-feedback/">Feedback</a>
                  </li>
                  <li>
                    <a href="https://www.msla.org/about-msla/privacy-policy/">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.navigationSection}>
              <div className={classes.centerContainer}>
                <div className={classes.navigationSectionTitle}>Reports</div>
                <ul className={classes.links}>
                  <li>
                    <Link to={ROUTE_CONSTANTS.REPORT_PREMIUM_TREND}>Premium Trend</Link>
                  </li>
                  <li>
                    <Link to={ROUTE_CONSTANTS.REPORT_TRANSACTION_TYPE_COMPARISON}>
                      Transaction Type Comparison
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTE_CONSTANTS.INSURER}>Insurer Data Sheet</Link>
                  </li>
                  <li>
                    <Link to={ROUTE_CONSTANTS.COUNTY}>County Data Sheet</Link>
                  </li>
                  <li>
                    <Link to={ROUTE_CONSTANTS.COVERAGECODE}>Coverage Code Data Sheet</Link>
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.copyright}>
              &copy; 2022 Mississippi Surplus Lines Association
            </Grid>
          </Grid>
        </footer>
      </Container>
    </div>
  );
};

export default Footer;
